import { SortOptionsEnum } from '../types/filters';

export const DEFAULT_SORT = SortOptionsEnum.TRENDING;
